import React, { useRef, useEffect } from 'react';
import { useLocation } from 'react-router';
import { scrollToTop as scrollToTopUtil } from '@/utils/helpers';

export const ScrollToTop = ({ children, ...props }) => {
  const ref = useRef();
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToTopUtil({ behavior: 'auto' });
  }, [pathname]);

  return (
    <div id={'app-container'} ref={ref} {...props}>
      {children}
    </div>
  );
};

export const scrollToTop = () => {
  scrollToTopUtil({ behavior: 'smooth' });
};
